import script from "./sdg-impact-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./sdg-impact-card.vue?vue&type=script&setup=true&lang=ts"

import "./sdg-impact-card.vue?vue&type=style&index=0&id=3a80f1e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a80f1e4"]])

export default __exports__